import getRuntimeEnv from 'helpers/getRuntimeEnv';

export const getDomain = () => {
  const { DOMAIN } = getRuntimeEnv();
  return DOMAIN;
};

// Context path App Builder is served on, without a trailing slash. Use this instead of
// process.env.PUBLIC_URL: the build-time value is baked to /app-builder and is wrong
// whenever the app is mounted under a different prefix.
export const getPublicUrl = () => {
  const { PUBLIC_URL } = getRuntimeEnv();
  return PUBLIC_URL;
};
